import type { TripListStatusValue } from './tripListTypes'
import TripListFilterMenuItem from './TripListFilterMenuItem'

interface Props {
  status: TripListStatusValue
  label: string
  count: number
  selected: boolean
  onToggle: (status: TripListStatusValue) => void
}

function StatusFilterMenuItem({ status, label, count, selected, onToggle }: Props) {
  return (
    <TripListFilterMenuItem
      value={status}
      label={label}
      count={count}
      selected={selected}
      onToggle={onToggle}
    />
  )
}

export default StatusFilterMenuItem
